module.exports = __webpack_public_path__ + "static/img/meetVictor.4abc78e8.png";